module.exports = __webpack_public_path__ + "img/0Q3B3332_P_T_L_Foamcore.9dc240c3.jpg";